import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { noticeAPI } from '../../services/api';
import socketService from '../../services/socket';
import './NoticeSlider.css';

/**
 * 루미나 공지 슬라이더 — 블랙 `NoticeSliderAPI.jsx` 의 화면 층 신작. 조회(슬라이더용 공지 API)·실시간 갱신 이벤트·소켓 연결은 원본 그대로.
 *   라벨 필 + 문구가 왼쪽으로 흐르는 띠(.notice-bar). 종류(urgent·event·warning·notice)별 라벨 색. 클릭하면 공지사항 탭으로.
 *   블랙은 JS 로 animation 을 계산했지만 루미나는 목록을 2벌 이어 붙여 CSS(nt-marq)로 흐른다.
 */
const TYPE_CLASS = { urgent: 'nt-urgent', event: 'nt-event', warning: 'nt-warn', notice: 'nt-notice' };

const NoticeSliderAPI = () => {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSliderNotices = async () => {
      try {
        const response = await noticeAPI.getSliderNotices();
        if (response.success && response.data) {
          const filteredNotices = response.data.filter(notice =>
            notice.target === 'all' || notice.target === 'user' || !notice.target
          );
          setNotices(filteredNotices);
        }
      } catch (error) {
        console.error('슬라이더 공지사항 조회 실패:', error);
        setNotices([{ type: 'notice', label: '공지', text: '공지사항을 불러올 수 없습니다.' }]);
      } finally {
        setLoading(false);
      }
    };
    fetchSliderNotices();
  }, []);

  useEffect(() => {
    const handleNoticeSliderUpdate = () => {
      const fetchSliderNotices = async () => {
        try {
          const response = await noticeAPI.getSliderNotices();
          if (response.success && response.data) {
            const filteredNotices = response.data.filter(notice =>
              notice.target === 'all' || notice.target === 'user' || !notice.target
            );
            setNotices(filteredNotices);
          }
        } catch (error) {
          console.error('슬라이더 공지사항 조회 실패:', error);
        }
      };
      fetchSliderNotices();
    };
    window.addEventListener('noticeSliderUpdate', handleNoticeSliderUpdate);
    if (!socketService.connected) {
      socketService.connect();
    }
    return () => {
      window.removeEventListener('noticeSliderUpdate', handleNoticeSliderUpdate);
    };
  }, []);

  const items = (loading || notices.length === 0)
    ? [{ type: 'notice', label: '공지', text: loading ? '공지사항을 불러오는 중...' : '표시할 공지사항이 없습니다.' }]
    : notices;
  const render = (prefix) => items.map((n, i) => (
    <span key={`${prefix}-${i}`} className={`nt-item ${TYPE_CLASS[n.type] || 'nt-notice'}`}>
      <span className="nt-lbl">{n.label}</span><span>{n.text}</span>
    </span>
  ));

  return (
    <div className="notice-bar" role="button" tabIndex={0} aria-label="공지사항" onClick={() => navigate('/mypage/event?tab=notice')} onKeyDown={(e) => { if (e.key === 'Enter') navigate('/mypage/event?tab=notice'); }}>
      <div className="nt-track">{render('a')}{render('b')}</div>
    </div>
  );
};

export default NoticeSliderAPI;
